
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categories",
      function () {
        return require("private-next-pages/categories/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/categories"])
      });
    }
  